import debug from 'bows';
import throttle from './_throttle';
import getScrollY from './_get-scroll-y';

const log = debug('HeaderReveal');

export default class {
	/**
	 * Constructor
	 * @param {HTMLElement} node
	 * @param {object} opts
	 * @return this
	 */
	constructor( node, opts = {} ) {
		this.node = ( typeof node === 'string' ) ? document.querySelector( node ) : node;
		this.opts = Object.assign( {
			revealedClass: 'header--revealed',
			concealedClass: 'header--concealed',
			revealedEvent: 'header.revealed',
			concealedEvent: 'header.concealed',
			threshold: 20,
			throttle: 50,
		}, opts );

		this.adminBar = document.getElementById('wpadminbar');

		if ( ! ( this.node instanceof HTMLElement ) ) {
			return;
		}

		this.visible = true; // visible means reset or revealed
		this.revealed = false; // revealed means revealed and not reset
		this.scrollY = getScrollY();
		this.opts.threshold = Math.abs(this.opts.threshold);

		const throttled = throttle( () => {
			let scrollY = getScrollY();

			// reset it at the top of the page
			if ( ( this.adminBar && scrollY <= this.adminBar.offsetHeight ) || ( ! this.adminBar && scrollY === 0 ) ) {
				this.reset();
				this.scrollY = scrollY;
				log('reset', scrollY, this.scrollY);
				return;
			}

			// conceal if scrolling below the threshold and we are below the height of the header
			log(scrollY, this.node.offsetHeight);
			if ( this.visible && scrollY > this.scrollY + this.opts.threshold && scrollY > this.node.offsetHeight ) {
				this.conceal();
				this.scrollY = scrollY;
				log('conceal', scrollY, this.scrollY);
				return;
			}

			// reveal if hidden and scrolling above the threshold
			if ( ! this.revealed && scrollY <= this.scrollY - this.opts.threshold ) {
				this.reveal();
				this.scrollY = scrollY;
				log('reveal', scrollY, this.scrollY);
				return;
			}

			this.scrollY = scrollY;
		}, this.opts.throttle );

		window.addEventListener('scroll', throttled);
		window.addEventListener('resize', throttled);

		// disable the header reveal on anchor links so the target isn't hidden by the header
		document.addEventListener('click', (e) => {
			let node = e.target;

			while( node.parentNode && node.tagName !== 'A' ) {
				node = node.parentNode;
			}

			if ( node && node.tagName === 'A' && node.hash ) {
				this.conceal();
				window.removeEventListener('scroll', throttled);
				setTimeout(() => window.addEventListener('scroll', throttled), 1000 );
			}
		});
	}

	/**
	 * Conceal the node
	 */
	conceal() {
		this.revealed = false;
		this.visible = false;
		this.node.classList.remove(this.opts.revealedClass);
		this.node.classList.add(this.opts.concealedClass);
		this.node.dispatchEvent(new CustomEvent(this.opts.concealedEvent));
		log('concealed');
	}

	/**
	 * Reveal the node
	 */
	reveal() {
		this.revealed = true;
		this.visible = true;
		this.node.classList.add(this.opts.revealedClass );
		this.node.classList.remove(this.opts.concealedClass);
		this.node.dispatchEvent(new CustomEvent(this.opts.revealedEvent));
		log('revealed');
	}

	/**
	 * Reset the node to original status
	 */
	reset() {
		this.revealed = false;
		this.visible = true;
		this.node.classList.remove(this.opts.revealedClass);
		this.node.classList.remove(this.opts.concealedClass);
		log('reset');
	}
}
